import { render, staticRenderFns } from "./SkeletonSwitch.vue?vue&type=template&id=a40e89e2&scoped=true&"
import script from "./SkeletonSwitch.vue?vue&type=script&lang=js&"
export * from "./SkeletonSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonSwitch.vue?vue&type=style&index=0&id=a40e89e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40e89e2",
  null
  
)

export default component.exports